
import { useState } from "react"
import AdminTable from "../../../componentsV2/adminsTable"
import ActivityLogs from "../../../componentsV2/ActivityLogs"
import Profile from "../../../componentsV2/Profile"
import AgentCommission from "../../../componentsV2/AgentCommission"
import { Tabs, TabsProps } from "antd"

export default function AdminSettingsPage() {
  const active = sessionStorage.getItem('active-settings-tab');
  const [activeTab, setActiveTab] = useState<"profile" | "admins" | "logs">("profile");
  // const [filters, setFilters] = useState();

  const tabItems: TabsProps["items"] = [
    {
      key: 'profile',
      label: "Profile",
      children: <Profile />,
    },
    {
      key: 'admins',
      label: "Admins",
      children: <AdminTable />,
    },
    {
      key: 'logs',
      label: "Activity Logs",
      children: <ActivityLogs />,
    },
    {
      key: 'commission',
      label: "Agent Commission",
      children: <AgentCommission />,
    },
  ];
    return (

        <main className="flex-1 h-full w-full">
            <div className=" mx-auto bg-white rounded-lg shadow-sm p-6">
                <div className="flex items-center mb-6">
                    <h1 className="text-xl font-medium  text-primary">Settings</h1>
                </div>

                <Tabs
                    defaultActiveKey={active || 'profile'}
                    items={tabItems}
                    onChange={(key) => {
                      sessionStorage.setItem('active-settings-tab', key);
                      setActiveTab(key as typeof activeTab);
                    }}
                    // tabBarExtraContent={activeTab === 'logs'
                    //   ? <ActivityLogsFilter onChange={(vals) => setFilters(vals)} />
                    //   : undefined}
                />
            </div>
        </main>
    )
}

